module.exports = __webpack_public_path__ + "img/rotation_2.2c2e832a.png";